module.exports = __webpack_public_path__ + "static/media/registry-icon.7c45b3f6.svg";